<template>
  <div class="home">
    <top class="home_top" :logo="fba"></top>
    <div class="contact" v-show="false">
      <div class="contact-item" onclick="openJesongChatByGroup(33395,41543);return false;">
        <div>
          <img style="width: 30px" src="../home/img/客服.png" alt="">
        </div>
        在线客服
      </div>
      <div class="contact-phone" @mouseover="hoverDetail" @mouseleave="deleteDetail">
        <div>
          <img style="width: 30px" src="../home/img/电话.png" alt="">
        </div>
        电话咨询
        <div v-if="phoneShow" id="phone1" class="detail-phone">0750-3921090</div>
      </div>
      <div class="contact-phone" @mouseover="hoverCodeDetail" @mouseleave="deleteCodeDetail">
        <div>
          <img style="width: 30px" src="../home/img/微信.png" alt="">
        </div>
        关注公众号
        <div v-if="codeShow" id="code" class="detail-code">
          <img style="width: 70px" src="../home/img/公众号.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="navimg">
      <el-carousel  height="50vh" :interval="seconds">
        <el-carousel-item v-for="(item, index) in imgLink" :key="index">
          <!-- <h3>{{ item }}</h3> -->
          <img style="height:50vh;" :src="require('../home/img/' + item)" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <calm></calm>
    <!-- <calm-module class="calm home_width"></calm-module> -->
    <div class="icon">
      <div class="icon-item" v-for="(item, index) in iconData" :key="index">
        <div class="icon-item__img">
          <img :src="require('./img/' + item.link)" alt="">
        </div>
        <div class="icon-item__word">
          <div class="icon-item__word--head">{{ item.name }}</div>
          <div class="icon-item__word--bottom">{{ item.detail }}</div>
        </div>
      </div>
    </div>
    <div class="adver" style="background-color: #FFF">
      <div class="adver-left">
        <div class="adver-left__title">亚马逊选品利润预算</div>
        <div class="adver-left__center" v-for="(item, index) in adverFirst.adverOne" :key="index">
          <div class="adver-left__center--icon">
            <img src="./img/播放.png" alt="">
          </div>
          <div class="adver-left__center--word">{{ item }}</div>
        </div>
        <div class="adver-left__bottom">
          <div class="adver-left__bottom--item" v-for="(item1, index1) in adverFirst.buttom" :key="index1" :style="{backgroundColor: item1.color}">
            <!-- <div class="adver-left__bottom--item__icon">
              <img :src="require('./img/' + item1.icon)" alt="">
            </div> -->
            <div class="adver-left__bottom--item__word" @click="adverBtnClick()">{{ item1.word }}</div>
          </div>
        </div>
      </div>
      <div class="adver-right">
        <div class="navimg">
          <!-- <img class="navimg-img" src="./img/start.png" alt=""> -->
          <el-carousel  height="300px">
            <!-- <el-carousel-item v-for="item in 4" :key="item">
              <h3 class="small">{{ item }}</h3>
            </el-carousel-item> -->
            <el-carousel-item v-for="(item, index) in oneLink" :key="index">
              <!-- <h3>{{ item }}</h3> -->
              <img style="width: 90%" :src="require('./img/' + item)" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="adver">
      <div class="adver-right">
        <div class="navimg">
          <!-- <img class="navimg-img" src="./img/start.png" alt=""> -->
          <el-carousel  height="300px">
            <!-- <el-carousel-item v-for="item in 4" :key="item">
              <h3 class="small">{{ item }}</h3>
            </el-carousel-item> -->
            <el-carousel-item v-for="(item, index) in twoLink" :key="index">
              <!-- <h3>{{ item }}</h3> -->
              <img style="width: 100%" :src="require('./img/' + item)" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="adver-left">
        <div class="adver-left__title">亚马逊FBA在售商品(站内站外一体化)利润核算</div>
        <div class="adver-left__center" v-for="(item, index) in adverSecond.adverOne" :key="index">
          <div class="adver-left__center--icon">
            <img src="./img/播放.png" alt="">
          </div>
          <div class="adver-left__center--word">{{ item }}</div>
        </div>
        <div class="adver-left__bottom" style="justify-content: flex-end;">
          <div class="adver-left__bottom--item" v-for="(item1, index1) in adverSecond.buttom" :key="index1" :style="{backgroundColor: item1.color}">
            <!-- <div class="adver-left__bottom--item__icon">
              <img :src="require('./img/' + item1.icon)" alt="">
            </div> -->
            <div class="adver-left__bottom--item__word" @click="adverBtnClick()">{{ item1.word }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="adver" style="background-color: #FFF">
      <div class="adver-left">
        <div class="adver-left__title">亚马逊店铺利润汇总及公司整体利润核算</div>
        <div class="adver-left__center" v-for="(item, index) in adverThird.adverOne" :key="index">
          <div class="adver-left__center--icon">
            <img src="./img/播放.png" alt="">
          </div>
          <div class="adver-left__center--word">{{ item }}</div>
        </div>
        <div class="adver-left__bottom">
          <div class="adver-left__bottom--item" v-for="(item1, index1) in adverThird.buttom" :key="index1" :style="{backgroundColor: item1.color}">
            <!-- <div class="adver-left__bottom--item__icon">
              <img :src="require('./img/' + item1.icon)" alt="">
            </div> -->
            <div class="adver-left__bottom--item__word" @click="adverBtnClick()">{{ item1.word }}</div>
          </div>
        </div>
      </div>
      <div class="adver-right">
        <div class="navimg">
          <!-- <img class="navimg-img" src="./img/start.png" alt=""> -->
          <el-carousel  height="300px">

            <!-- <el-carousel-item v-for="item in 4" :key="item">
              <h3 class="small">{{ item }}</h3>
            </el-carousel-item> -->
            <el-carousel-item v-for="(item, index) in threeLink" :key="index">
              <!-- <h3>{{ item }}</h3> -->
              <img style="width: 100%" :src="require('./img/' + item)" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="adver">
      <div class="adver-right">
        <div class="navimg">
          <!-- <img class="navimg-img" src="./img/start.png" alt=""> -->
          <el-carousel  height="300px">
            <!-- <el-carousel-item v-for="item in 4" :key="item">
              <h3 class="small">{{ item }}</h3>
            </el-carousel-item> -->
            <el-carousel-item v-for="(item, index) in fourLink" :key="index">
              <!-- <h3>{{ item }}</h3> -->
              <img style="width: 100%" :src="require('./img/' + item)" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="adver-left">
        <div class="adver-left__title">亚马逊多店铺及人员管理</div>
        <div class="adver-left__center" v-for="(item, index) in adverFouth.adverOne" :key="index">
          <div class="adver-left__center--icon">
            <img src="./img/播放.png" alt="">
          </div>
          <div class="adver-left__center--word">{{ item }}</div>
        </div>
        <div class="adver-left__bottom" style="justify-content: flex-end;">
          <div class="adver-left__bottom--item" v-for="(item1, index1) in adverFouth.buttom" :key="index1" :style="{backgroundColor: item1.color}">
            <!-- <div class="adver-left__bottom--item__icon">
              <img :src="require('./img/' + item1.icon)" alt="">
            </div> -->
            <div class="adver-left__bottom--item__word" @click="adverBtnClick()">{{ item1.word }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="adver" style="background-color: #FFF">
      <div class="adver-left">
        <div class="adver-left__title">数据运营实战技巧</div>
        <div class="adver-left__center" v-for="(item, index) in adverFifth.adverOne" :key="index">
          <div class="adver-left__center--icon">
            <img src="./img/播放.png" alt="">
          </div>
          <div class="adver-left__center--word">{{ item }}</div>
        </div>
        <div class="adver-left__bottom">
          <div class="adver-left__bottom--item" v-for="(item1, index1) in adverFifth.buttom" :key="index1" :style="{backgroundColor: item1.color}">
            <!-- <div class="adver-left__bottom--item__icon">
              <img :src="require('./img/' + item1.icon)" alt="">
            </div> -->
            <div class="adver-left__bottom--item__word" @click="adverBtnClick()">{{ item1.word }}</div>
          </div>
        </div>
      </div>
      <div class="adver-right">
        <div class="navimg">
          <!-- <img class="navimg-img" src="./img/start.png" alt=""> -->
          <el-carousel  height="300px">
            <!-- <el-carousel-item v-for="item in 4" :key="item">
              <h3 class="small">{{ item }}</h3>
            </el-carousel-item> -->
            <el-carousel-item v-for="(item, index) in fifLink" :key="index">
              <!-- <h3>{{ item }}</h3> -->
              <img style="width: 100%" :src="require('./img/' + item)" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="adver">
      <div class="adver-right">
        <div class="navimg">
          <!-- <img class="navimg-img" src="./img/start.png" alt=""> -->
          <el-carousel  height="300px">
            <!-- <el-carousel-item v-for="item in 4" :key="item">
              <h3 class="small">{{ item }}</h3>
            </el-carousel-item> -->
            <el-carousel-item v-for="(item, index) in twoLink" :key="index">
              <!-- <h3>{{ item }}</h3> -->
              <img style="width: 100%" :src="require('./img/' + item)" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="adver-left">
        <div class="adver-left__title">亚马逊FBA物流自动报价及订购</div>
        <div class="adver-left__center" v-for="(item, index) in adverSix.adverOne" :key="index">
          <div class="adver-left__center--icon">
            <img src="./img/播放.png" alt="">
          </div>
          <div class="adver-left__center--word">{{ item }}</div>
        </div>
        <div class="adver-left__bottom" style="justify-content: flex-end;">
          <div class="adver-left__bottom--item" v-for="(item1, index1) in adverSix.buttom" :key="index1" :style="{backgroundColor: item1.color}">
            <!-- <div class="adver-left__bottom--item__icon">
              <img :src="require('./img/' + item1.icon)" alt="">
            </div> -->
            <div class="adver-left__bottom--item__word" @click="adverBtnClick()">{{ item1.word }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="adver" style="background-color: #FFF">
      <div class="adver-left">
        <div class="adver-left__title">进销存财ERP一体化管理</div>
        <div class="adver-left__center" v-for="(item, index) in adverSeven.adverOne" :key="index">
          <div class="adver-left__center--icon">
            <img src="./img/播放.png" alt="">
          </div>
          <div class="adver-left__center--word">{{ item }}</div>
        </div>
        <div class="adver-left__bottom">
          <div class="adver-left__bottom--item" v-for="(item1, index1) in adverSeven.buttom" :key="index1" :style="{backgroundColor: item1.color}">
            <!-- <div class="adver-left__bottom--item__icon">
              <img :src="require('./img/' + item1.icon)" alt="">
            </div> -->
            <div class="adver-left__bottom--item__word" @click="adverBtnClick()">{{ item1.word }}</div>
          </div>
        </div>
      </div>
      <div class="adver-right">
        <div class="navimg">
          <!-- <img class="navimg-img" src="./img/start.png" alt=""> -->
          <el-carousel  height="300px">

            <!-- <el-carousel-item v-for="item in 4" :key="item">
              <h3 class="small">{{ item }}</h3>
            </el-carousel-item> -->
            <el-carousel-item v-for="(item, index) in threeLink" :key="index">
              <!-- <h3>{{ item }}</h3> -->
              <img style="width: 100%" :src="require('./img/' + item)" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="cooperation" v-if="false">
      <h1>合作伙伴</h1>
    </div>
    <div class="brief">
      <div class="brief-top">

      </div>
      <div class="brief-center">
        <div class="brief-center__left">
          <img src="../../assets/img/logo2.png" alt="">
          <div class="brief-center__left--top">
            江门市链想力科技有限公司成立于2021年4月,专注跨境电商SAAS系统及相关项目的研发。
          </div>
          <div class="brief-center__left--center">
            {{ textOne }}础但最难的 "亚马逊商品及店铺站内站外一体化利润精准计算的问题" 以及最前沿的“数字化高效进销存财管理，
            智慧跨境物流在线计价，订购, 发运"等一系列问题。我们将一如既往地协助广大亚马逊及跨境卖家提高工作效率，节省工作时间 ，提升数据化运营能力，实现利润最大化同时最大程度地降低运营亏损的风险。
          </div>
        </div>
        <div class="brief-center__center">
          <div class="brief-center__center--top">联系我们</div>
          <div class="brief-center__center--item" v-for="(item, index) in chatData" :key="index">
            <div class="brief-center__center--item__left">{{ item.name }}</div>
            <div class="brief-center__center--item__right">{{ item.value }}</div>
          </div>
        </div>
        <div class="brief-center__right" style="opacity: 0;">
          <img style="width: 130px" src="../home/img/公众号二维码1.png" alt="">
          <div style="width: 132px;text-align:center">关注公众号以获取更新通知及免费帐户</div>
        </div>
      </div>
      <div class="brief-bottom">
        <span> Copyright  2021 江门市链想力科技有限公司 版权所有 <span class="ICP" @click="click">粤ICP备2021068188号</span> </span>
        <span class="click-span" @click="navClick(1)">隐私政策</span>
        <span class="click-span" @click="navClick(2)">服务条款</span>
        <span id='cnzz_stat_icon_1280727273'></span>
      <remote-script src="https://s9.cnzz.com/z_stat.php?id=1280727273&show=pic"></remote-script>

      </div>
    </div>
  </div>
</template>


<script>
  import top from "../../components/content/top";
  // import calmModule from '../home/components/common/calmModule'
  import calm from '../calm/component/content/calmModule'
  import 'common/importJS'

  export default {
    name: "Home",
    components: {
      'top': top,
      // 'calmModule': calmModule,
      'calm': calm
    },
    data() {
      return {
        textOne:'<护航鲸ERP> 是公司最近研发的亚马逊多店铺运营管理ERP系统。该项目旨在为广大亚马逊卖家解决最基',
        fba: true,
        imgLink: [
          // '广告图1.jpg',
          // '广告图2.jpg'
          // '稿定设计-1.jpg',
          // '稿定设计-2.jpg',
          '稿定设计-4.jpg',
          '稿定设计-3.jpg',
          '稿定设计-5.jpg',
          '稿定设计-6.jpg',
        ],
        oneLink:[
          '1-11.png',
          '1-22.png'
        ],
        twoLink:[
          '2-1.jpg'
        ],
        threeLink:[
          '3-1.jpg'
        ],
        fourLink:[
          '4-1.jpg'
        ],
        fifLink:[
          '5-1.jpg'
        ],
        seconds:8000,
        // 图片父容器高度
        bannerHeight: 1000,
        // 浏览器宽度
        screenWidth: 0,
        phoneShow:false,
        codeShow:false,
        iconData:[
          {
            link:'沙漏.png',
            name:'减少亏损风险',
            detail:'实时监控及时发现与修复亏损产品'
          },
          {
            link:'火箭.png',
            name:'利润最大化',
            detail:'准确可靠的数据化运营分析，提升产品利润'
          },
          {
            link:'沙漏.png',
            name:'快速反应，提效省时',
            detail:'实时数据，提供高效及可靠的决策支持'
          },
          {
            link:'统计.png',
            name:'监控关键绩效指标',
            detail:'汇总看板能提供关键绩效指标及视图'
          },
        ],
        adverFirst:{
          adverOne:[
            '只花几分钟输入产品数据，立刻为您“免费提供亚马逊选品利润预算”',
            '一键计算亚马逊FBA商品站内外所有细分项成本与费用 (含头程物流，商品入口关税，站外测评，站外引流，站内PPC广告，合仓配置，仓储，退货，汇损，帐户月费等):',
            '竞争分析，可对“同行竞品的利润快速进行估算”'
          ],
          buttom:{
            one:{
              word:'免费试用',
              color:'rgb(251,171,5)',
              icon:'勋章.png'
            },
            two:{
              word:'视频讲解',
              color:'rgb(156,226,6)',
              icon:'24gf.png'
            }
          }
        },
        adverSecond:{
          adverOne:[
            '无需重复输入, 1次性保存"在售商品核算"数据,之后按日期上传汇总报告，系统将自动更新每月销量,退货量,库存量,站内PPC广告费,站外测评费,站外引流费等"实时核算汇总产品利润;',
            '系统同时快速汇总所有在售商品的总销量，然后对亚马逊店铺固定费用分摊到每个在售Listing商品中,准确并合理计算出每个商品的所承担的“帐户每月固定费用";'
          ],
          buttom:{
            one:{
              word:'免费试用',
              color:'rgb(251,171,5)',
              icon:'勋章.png'
            },
            two:{
              word:'视频讲解',
              color:'rgb(156,226,6)',
              icon:'24gf.png'
            }
          }
        },
        adverThird:{
          adverOne:[
            '帮助您专注与提升商品的盈利及销量，并使您快速发现亏损商品，及时分析原因，扭亏为盈;',
            '店铺利润数据随时随地，实时更新反馈，避免不知不觉，后知后觉带来的亏损风险;',
            '由商品细分项成本到汇总成本，由商品利润到店铺利润，由过程到结果，每个细节环环相扣，可快速定位问题，解决问题及优化利润;'
          ],
          buttom:{
            one:{
              word:'免费试用',
              color:'rgb(251,171,5)',
              icon:'勋章.png'
            },
            two:{
              word:'视频讲解',
              color:'rgb(156,226,6)',
              icon:'24gf.png'
            }
          }
        },
        adverFouth:{
          adverOne:[
            '每个会员帐户最多可支持5个店铺的总销量，总销售额，总库存量,总库存价值,总应收款，总应付款,现金流状况,总资产，总利润及综合利润率的汇总管理;',
            'BOSS版帐户最多可支持20个子帐户的数据汇总，Boss可对每 个店铺或每个店管员的业绩表现进行独立评估;',
            '超简洁易用的操作界面及汇总看板，让您一目了然，快速决策;同时又可点击查看细节，掌控全局;'
          ],
          buttom:{
            one:{
              word:'免费试用',
              color:'rgb(251,171,5)',
              icon:'勋章.png'
            },
            two:{
              word:'视频讲解',
              color:'rgb(156,226,6)',
              icon:'24gf.png'
            }
          }
        },
        adverFifth:{
          adverOne:[
            '通过实时的数据反馈，分析站内PPC广告费用，站外引流费用，站外测评费用，优化库存数量，商品销售价格，退货量等与销售量之间的变化，针对竞争可快速调节数据并进行心有成竹的价格战及广告战。最终赢在对数据的把握及反应速度。'
          ],
          buttom:{
            one:{
              word:'免费试用',
              color:'rgb(251,171,5)',
              icon:'勋章.png'
            },
            two:{
              word:'视频讲解',
              color:'rgb(156,226,6)',
              icon:'24gf.png'
            },
            // three:{
            //   word:'浏览器插件下载',
            //   color:'rgb(81,142,249)',
            //   icon:'云下载.png'
            // }
          }
        },
        adverSix:{
          adverOne:[
            '用户可以根据"每个FBA发补货单"进行跨境物流实时计价及订购；',
            '当用户有多个FBA发补货单要进行发货时，系统还可智能判断是否可以合并发运，为用户节省物流费用；',
            '由物流自动报价到订购，由自动安排上门收件到仓库收货检验，由货运保险到物流跟踪，提供系统化流程化管理；'
          ],
          buttom:{
            one:{
              word:'免费试用',
              color:'rgb(251,171,5)',
              icon:'勋章.png'
            },
            two:{
              word:'视频讲解',
              color:'rgb(156,226,6)',
              icon:'24gf.png'
            },
            // three:{
            //   word:'浏览器插件下载',
            //   color:'rgb(81,142,249)',
            //   icon:'云下载.png'
            // }
          }
        },
        adverSeven:{
          adverOne:[
            '智能采购管理：一单到底，当生成“FBA发补货计划单”同时自动生成"采购计划单"；本系统智能分拆及合并"采购计划单"后直接根据不同供应商自动生成"采购单"，进一步智能提效及节省人力；',
            '智能发货管理：一单到底，当生成“FBA发补货计划单”同时自动生成“发货计划单”，本系统根据是否符合条件，智能合并"发货计划单"后直接自动生成"发货单"，进一步智能提效及节省人力；',
            '智能库存管理：通过智能的出入仓管理，对多国多仓的商品库存状态及库存分类管理，细分不同状态下的库存量及能准确汇总实时库存价值；',
            '智能业财一体化: 业财数据贯通，实时资金管理，自动记帐，款帐核销，多维利润报表生成；',
            '数据闭环，直正实现全盘一体化：结合系统自带的物流在线报价及订购系统，使物流单价数据成为闭环数据，使真正实现数据一体化管理，更有利于经营分析，风险预警及快速决策：'
          ],
          buttom:{
            one:{
              word:'免费试用',
              color:'rgb(251,171,5)',
              icon:'勋章.png'
            },
            two:{
              word:'视频讲解',
              color:'rgb(156,226,6)',
              icon:'24gf.png'
            },
            // three:{
            //   word:'浏览器插件下载',
            //   color:'rgb(81,142,249)',
            //   icon:'云下载.png'
            // }
          }
        },
        chatData:[
          {
            name: '联系电话：',
            value: '13380967750'
          },
          {
            name: '建议投诉：',
            value: 'info@whaleerp.com'
          },
          {
            name: '投资咨询',
            value: 'artechco@126.com'
          },
          {
            name: '工作时间：',
            value: '9:00~12:00am 14:00~18:00pm (周一至周六)'
          },
          {
            name: '公司地址：',
            value: '江门市蓬江区胜利路152号珠西创谷2410'
          }
        ]
      }
    },
    methods: {
      hoverDetail(){
        this.phoneShow = true
        var obj = document.getElementById("phone1");
        if(obj){
          obj.style.marginRight= "70px";
        }

      },
      deleteDetail(){
        this.phoneShow = false
        var obj = document.getElementById("phone1");
        if(obj){
          obj.style.marginRight= "0px";
        }
      },
      hoverCodeDetail(){
        this.codeShow = true
        var obj = document.getElementById("code");
        if(obj){
          obj.style.marginRight= "70px";
        }

      },
      deleteCodeDetail(){
        this.codeShow = false
        var obj = document.getElementById("code");
        if(obj){
          obj.style.marginRight= "0";
        }
      },
      click(){
        window.open('https://beian.miit.gov.cn/#/Integrated/index')
      },
      navClick(index){
        if(index === 0){
          window.open('/law/WhaleERP免责声明.html')
        }else if(index === 1){
          window.open('/law/WhaleERP隐私政策.html')
          // window.open('/law/Amzjoin隐私政策.html')
        }else if(index === 2){
          window.open('/law/WhaleERP用户服务条款.html')
          // window.open('/law/Amzjoin用户服务条款.html')
        }
      },
      adverBtnClick(){
        this.$message.error('暂未开通，敬请期待')
      }
    },
    created(){
      const loading = this.$loading({
        lock: true,
        text: 'loading',
      })
      setTimeout(() => {
        loading.close()
      }, 500);

    }
  }

</script>

<style scoped lang="scss">
.home_width{
  width: 70%;
}
.ICP:hover{
  cursor: pointer;
  color: #ff7f17;
}
.contact{
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 10;
    transform: translateY(10%);
  }

  .contact-item{
    padding: 10px;
    text-align: center;
    color: #ffffff;
    background-color: rgb(45,154,228);
  }

  .contact-item:hover{
    cursor: pointer;
  }

  .contact-phone{
    position: relative;
    padding: 10px;
    text-align: center;
    color: #ffffff;
    background-color: rgb(22,193,200);
  }

  .detail-phone{
    text-align: center;
    color: rgb(22,193,200);
    background-color: #ffffff;
    position: absolute;
    top: 10px;
    width: 120px;
    padding: 12px 10px;
    /* font-width: bold; */
    font-size: 14px;
    height: 40px;
    right: 10px;
    /*margin-right: 70px;*/
    transition:margin-right 1s ease-in-out;
    -moz-transition:margin-right 1s ease-in-out; /* Firefox 4 */
    -webkit-transition:margin-right 1s ease-in-out; /* Safari and Chrome */
    -o-transition:margin-right 1s ease-in-out; /* Opera */
    /*border: 1px solid #a8a8a8;*/
  }

  .detail-phone:after{
    content: '';
    position: absolute;
    right: -6px;
    top: 12px;
    width: 10px;
    height: 10px;
    margin-bottom: -10px;
    background: inherit;
    transform: rotate(45deg);
    /*border-right: 1px solid #a8a8a8;*/
    /*border-top: 1px solid #a8a8a8;*/
  }

  .detail-code{
    text-align: center;
    color: rgb(22,193,200);
    background-color: #ffffff;
    position: absolute;
    top: 10px;
    width: 100px;
    height: 100px;
    padding: 12px 10px;
    /* font-width: bold; */
    font-size: 14px;
    right: 10px;
    /*margin-right: 70px;*/
    transition:margin-right 1s ease-in-out;
    -moz-transition:margin-right 1s ease-in-out; /* Firefox 4 */
    -webkit-transition:margin-right 1s ease-in-out; /* Safari and Chrome */
    -o-transition:margin-right 1s ease-in-out; /* Opera */
  }

  .detail-code:after{
    content: '';
    position: absolute;
    right: -6px;
    top: 12px;
    width: 10px;
    height: 10px;
    margin-bottom: -10px;
    background: inherit;
    transform: rotate(45deg);
    /*border-right: 1px solid #a8a8a8;*/
    /*border-top: 1px solid #a8a8a8;*/
  }
  .navimg img{
    position: absolute;
    left: 50%;
    overflow: hidden;
    top: 50%;
    transform: translate(-50%, -50%);
  }


  .home{
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background-color: rgb(241, 243, 255);
  }

  .navimg img{
    position: absolute;
    left: 50%;
    overflow: hidden;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .icon{
    background-color: #fff;
    border-radius: 10px;
    padding: 20px 10px;
    width: 1500px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    &-item{
      flex: 1;
      display: flex;
      align-items: center;
      &__img{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px solid #d3dce6;
        text-align: center;
        padding: 4px;
      }
      &__word{
        margin: 0 0 0 10px;
        &--head{
          font-weight: bold;
          font-size: 16px;
          margin-bottom: 8px;
        }
      }
    }
  }

  .adver{
    padding: 20px 170px;
    align-items: center;
    display: flex;
    min-height: 350px;
    // background-color: rgb(246,246,248);
    &-left{
      flex: 1;
      padding: 0 10px 0 0;
      &__title{
        font-size: 20px;
        font-weight: bold;
        margin: 20px 0;
      }
      &__center{
        // margin: 10px 0;
        display: flex;
        &--icon img{
          width: 12px;
          margin: 3px 5px 0 0;
        }
        &--word{
          line-height: 20px;
          color: #B8B1B1;
        }
      }
      &__bottom{
        display: flex;
        margin: 20px 0;
        &--item{
          display: flex;
          justify-content: center;
          background-color: rgb(156,226,6);
          // width: 120px;
          height: 38px;
          padding:  10px 15px;
          color: white;
          font-size: 16px;
          text-align: center;
          border-radius: 3px;
          margin-right: 5px;
          &:hover{
            opacity: .8;
            cursor: pointer;
          }
          &__icon{
            margin: 0 5px 0 0;
            & img{
            width: 18px;
          }
          }
        }
      }
    }
    &-right{
      margin-right: 30px;
      flex: 1;
    }
  }

  .cooperation{
    padding: 20px 170px;
    height: 300px;
    background-color: rgb(246,246,248);
    text-align: center;
  }

  .brief{
    height: 300px;
    background-color: rgb(25,43,139);
    color: #ffffff;
    &-top{
      padding: 20px 170px;
      height: 60px;
    }
    &-center{
      padding: 20px 170px;
      display: flex;
      &__left{
        flex: 2.2;
        position: relative;
        & img{
          width: 200px;
          position: absolute;
          top: -80px;
          left: -25px;
        }
        &--top{
          margin-bottom: 20px;
        }
        &--center{
          line-height: 20px;
          padding: 0 23px 0 0 ;
        }
      }
      &__center{
        flex: 2;
        margin-left: 28px;
        &--top{
          color: #FFF;
          font-weight: bold;
          font-size: 14px;
          margin-bottom: 15px;
        }
        &--item{
          margin: 5px;
          &__left{
            display: inline-block;
            width: 100px;

          }
          &__right{
            display: inline-block;
          }
        }
      }
      &__right{
        flex: 1;
      }
    }
    &-bottom{
      border-top: 1px solid rgba(52, 60, 87, 0.7);
      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      .click-span{
        margin:  0 5px;
      }

      .click-span:hover{
        cursor: pointer;
        color: #ff7f17;
      }
    }
  }



  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    /* opacity: 0.75; */
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    /* background-color: rgb(81,107,180) !important; */
    // background-color: white !important;
    /* background-color: #99a9bf; */
  }

  .el-carousel__item:nth-child(2n+1) {
    // background-color: white !important;
    /* background-color: red !important; */
    /* background-color: #d3dce6; */
  }

  .home_top{
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    z-index: 10;
  }

  .littleLogin{
    width: 10px;
    height: 10px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .chat-man{
    display: flex;
    justify-content: flex-end;
  }

  // .el-carousel__item:nth-child(2n) {
  //   background-color: #99a9bf;
  // }

  // .el-carousel__item:nth-child(2n+1) {
  //   background-color: #d3dce6;
  // }

  .contact{
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 10;
    transform: translateY(10%);
  }

  .contact-item{
    padding: 10px;
    text-align: center;
    color: #ffffff;
    background-color: rgb(45,154,228);
  }

  .contact-item:hover{
    cursor: pointer;
  }

  .contact-phone{
    position: relative;
    padding: 10px;
    text-align: center;
    color: #ffffff;
    background-color: rgb(22,193,200);
  }

  .detail-phone{
    text-align: center;
    color: rgb(22,193,200);
    background-color: #ffffff;
    position: absolute;
    top: 10px;
    width: 120px;
    padding: 12px 10px;
    /* font-width: bold; */
    font-size: 14px;
    height: 40px;
    right: 10px;
    /*margin-right: 70px;*/
    transition:margin-right 1s ease-in-out;
    -moz-transition:margin-right 1s ease-in-out; /* Firefox 4 */
    -webkit-transition:margin-right 1s ease-in-out; /* Safari and Chrome */
    -o-transition:margin-right 1s ease-in-out; /* Opera */
    /*border: 1px solid #a8a8a8;*/
  }

  .detail-phone:after{
    content: '';
    position: absolute;
    right: -6px;
    top: 12px;
    width: 10px;
    height: 10px;
    margin-bottom: -10px;
    background: inherit;
    transform: rotate(45deg);
    /*border-right: 1px solid #a8a8a8;*/
    /*border-top: 1px solid #a8a8a8;*/
  }

  .detail-code{
    text-align: center;
    color: rgb(22,193,200);
    background-color: #ffffff;
    position: absolute;
    top: 10px;
    width: 100px;
    height: 100px;
    padding: 12px 10px;
    /* font-width: bold; */
    font-size: 14px;
    right: 10px;
    /*margin-right: 70px;*/
    transition:margin-right 1s ease-in-out;
    -moz-transition:margin-right 1s ease-in-out; /* Firefox 4 */
    -webkit-transition:margin-right 1s ease-in-out; /* Safari and Chrome */
    -o-transition:margin-right 1s ease-in-out; /* Opera */
  }

  .detail-code:after{
    content: '';
    position: absolute;
    right: -6px;
    top: 12px;
    width: 10px;
    height: 10px;
    margin-bottom: -10px;
    background: inherit;
    transform: rotate(45deg);
    /*border-right: 1px solid #a8a8a8;*/
    /*border-top: 1px solid #a8a8a8;*/
  }
  .navimg{
    position: relative;
    &-img{
      position: absolute;
      top: 45%;
      left: 45%;
      z-index: 3;
      &:hover{
        opacity: .8;
        cursor: pointer;
      }
    }
  }
  /*.contact-item{*/
  /*  transition:margin-right 2s;*/
  /*  -webkit-transition:margin-right 2s ease-in-out;*/
  /*}*/

  /*.contact-item:hover{*/
  /*  margin-right: 100px;*/
  /*}*/
  // @media screen and (max-width: 1200px) {
  //   .navimg img{
  //     // height: 380px !important;
  //   }
  //   .navimg /deep/ .el-carousel__container{
  //     height: 380px !important;
  //   }


  // }
  // @media screen and (max-width: 1600px) {
  //   .home{
  //     min-width: 118rem;
  //     // padding-bottom: 5rem;
  //   }

  //   .icon{
  //     width: 1500px;
  //   }

  //   .home_width{
  //     min-width: 110rem;
  //     // height: 200px;
  //   }

  //   .quick{
  //     margin: 0.4rem auto;
  //     padding: 0.4rem 0 1.8rem;
  //   }

  //   /*.home_top{*/
  //   /*  padding: 0 18rem;*/
  //   /*}*/

  //   .calm{
  //     margin: 1rem auto 0.8rem;
  //   }

  //   .tools{
  //     margin: 0.4rem auto;
  //   }
  // }

  // @media screen and (min-width: 1600px){
  //   .home .navimg img{
  //     // width: auto !important;
  //   }
  //   .icon{
  //     width: 1500px;
  //   }
  //   .home{
  //     min-width: 1580px;
  //     // padding-bottom: 50px;
  //   }

  //   .home_width{
  //     min-width: 1500px;
  //     // height: 200px;
  //   }

  //   .icon{
  //     // padding: 20px 210px;

  //   }

  //   .adver{
  //     padding: 20px 210px;
  //   }
  //   .brief-center{
  //     padding: 20px 210px;
  //   }
  //   .quick{
  //     padding: 5px 0 20px;
  //     margin: 5px auto;
  //   }

  //   .home_top{
  //     padding: 0 200px;
  //   }

  //   .calm{
  //     margin: 5px auto 10px;

  //   }

  //   .tools{
  //     margin: 5px auto;
  //   }
  // }
</style>
<style>
  div .el-carousel__button{
    width: 10px !important;
  }
  div .el-carousel__indicator--horizontal{
    padding: 8px 4px;
  }
  .el-carousel__item{
    text-align: center !important;
  }
</style>
